import { Button, DatePicker, Form, Input, Radio, Select, Space } from "antd";
import React, { useEffect, useState, useCallback } from "react";
import { jcTypeArray } from "../../utils";
import axios from "axios";
import { authenticateToken } from "../../utils/auth";
import { responseNotification } from "../../utils/notify";
import ImageUploader from "../FileManager/upload";
import moment from "moment";
const { TextArea } = Input;
const { Option } = Select;

const AddCampaign = ({ visibleData, onCloseMethod }: any) => {
  const [appsImgUrl, setAppsImgUrl] = useState<string>();
  const [webImgUrl, setWebImgUrl] = useState<string>();
  const [toDate, setToDate] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [isFlashSale, setIsFlashSale] = useState<boolean>(false);

  const [startUpload, setStartUpload] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >(undefined);

  const [startUpload2, setStartUpload2] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >(undefined);

  const [error, setError] = useState("");
  const [bannerUrl, setBannerUrl] = useState(undefined);
  const [type, setType] = useState("JC_MART");
  const [campaignData, setCampaignData] = useState(undefined);

  const [campaignOptions, setCampainsOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [shopsOptions, setShopsOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [shopId, setShopId] = useState<any>();
  const [campaignParentId, setCampaignParentId] = useState<any>();

  const getCampaignsOptions = useCallback(async () => {
    setCampainsOptions({ loading: true, list: [] });

    const res = await axios.get(
      `${process.env.REACT_APP_CATALOG_READER_API}/campaign/all` +
        (type ? `?type=${type}` : ``),
      {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
        },
      }
    );

    setCampainsOptions({
      loading: false,
      list: res?.data?.campaigns?.map((campaign: { id: any; name: any }) => {
        return {
          id: campaign?.id,
          name: campaign?.name,
        };
      }),
    });
  }, [type]);

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (startUpload === "Uploaded" && startUpload2 === "Uploaded") {
      form?.submit();
    }
  }, [startUpload, startUpload2]);

  const onSubmit = async (data: any) => {
    if (appsImgUrl || webImgUrl) {
      setLoading(true);

      const readyData = data && {
        name: data.name,
        banner: appsImgUrl ? appsImgUrl : data?.banner,
        bannerWeb: webImgUrl ? webImgUrl : data?.bannerWeb,
        description: data.description,
        campaign: data.campaign,
        colorCode: data.colorCode,
        displayOrder: data.displayOrder,
        parentCampaign: data.parentCampaign,
        startAt: data.startAt,
        endAt: data.endAt,
        status: data.status,
        type: type || data?.type,
        shopId: data.shopId,
        isFlashSale: isFlashSale || data.isFlashSale,
      };
      if (campaignData) {
        await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/campaign`, {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...readyData,
            id: campaignData?.id,
            deleted: false,
          }),
        })
          .then((res) => res.json())
          .then((res) => {
            setLoading(false);

            if (res.statusCode === 200) {
              responseNotification("Campaign Updated Successfully", "success");
              form.resetFields();
              if (onCloseMethod) {
                onCloseMethod();
              }
            } else if (res.status === 500) {
              responseNotification("Internal server error", "error");
            } else {
              responseNotification(res.message || "something wrong", "warning");
            }
          })
          .catch((err) => {
            setLoading(false);
            responseNotification(`${"Internal server error"} ${err}`, "error");
            console.error("err", err);
          });
      } else {
        await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/campaign`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...readyData,
            deleted: false,
            status: true,
          }),
        })
          .then((res) => res.json())
          .then((res) => {
            setLoading(false);

            if (res.statusCode === 200) {
              responseNotification("campaign Create Successfully", "success");
              form.resetFields();
              if (onCloseMethod) {
                onCloseMethod();
              }
            } else if (res.status === 500) {
              responseNotification("Internal server error", "error");
            } else {
              responseNotification(res.message || "something wrong", "warning");
            }
          })
          .catch((err) => {
            setLoading(false);
            responseNotification(`${"Internal server error"} ${err}`, "error");
            console.error("err", err);
          });
      }
    } else {
      responseNotification(`Image required`, "error");
    }
  };

  const getShopsOptions = useCallback(
    async (val?: string) => {
      setShopsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${
          process.env.REACT_APP_CATALOG_READER_API
        }/shop/admin/search?page=0&limit=50&key=${val || ``}` +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setShopsOptions({
        loading: false,
        list: res?.data?.shops?.map((shop: any) => {
          return {
            id: shop?.id,
            name: shop?.name,
          };
        }),
      });
    },
    [type]
  );

  useEffect(() => {
    getCampaignsOptions();
    getShopsOptions();
  }, [getCampaignsOptions, getShopsOptions]);

  useEffect(() => {
    if (visibleData) {
      setCampaignData(visibleData);
      setType(visibleData?.type);
      setAppsImgUrl(visibleData?.banner);
      setWebImgUrl(visibleData?.bannerWeb);
      setFromDate(visibleData?.startAt);
    }
  }, [form, visibleData]);

  useEffect(() => {
    if (campaignData) {
      form.resetFields(Object.keys(visibleData || ""));
      setBannerUrl(visibleData?.banner);
      setWebImgUrl(visibleData?.bannerWeb);
    }
  }, [campaignData, visibleData]);

  const resetData = () => {
    form?.resetFields();
    setType("");
    setAppsImgUrl(undefined);
    setWebImgUrl(undefined);
    setStartUpload(undefined);
    setStartUpload2(undefined);
  };

  return (
    <div className="add-product drawer-toggle-wrapper">
      <div className="drawer-toggle-inner-wrapper">
        <Form
          name="control-hooks"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          className="ant-form ant-form-vertical"
          onFinish={onSubmit}
          form={form} // like ref
          layout="vertical"
          autoComplete="off"
          initialValues={{
            ...campaignData,
            startAt: moment(campaignData?.startAt),
            endAt: moment(campaignData?.endAt),
            type: type || campaignData?.type,
          }}
        >
          <Form.Item
            hasFeedback
            label="Campaign Type"
            rules={[
              {
                required: true,
                message: "Type is Required!",
              },
            ]}
            name="isFlashSale"
          >
            <Radio.Group
              onChange={(val) => setIsFlashSale((val as any).target.value)}
              value={isFlashSale}
            >
              <Space direction="vertical">
                <Radio value={false}>Regular Campaign</Radio>
                <Radio value={true}>Flash Sale</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Campaign Name"
            rules={[
              {
                required: true,
                message: "Campaign Name is Required!",
              },
            ]}
            name="name"
          >
            <Input id="name" type="text" placeholder="Enter Campaign Name" />
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Type"
            rules={[
              {
                required: true,
                message: "Type is required!",
              },
            ]}
            name="type"
          >
            <Select
              placeholder="Select Type"
              onChange={(val) => setType(val as string)}
            >
              {Object.values(jcTypeArray)?.map((type, i) => (
                <Select.Option value={type} key={i}>
                  {type?.replace("_", " ")}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Shop Name"
            name="shopId"
            className="mr-2"
          >
            <Select
              showSearch
              placeholder="Filter by Shop"
              optionFilterProp="children"
              onChange={(val) => setShopId(val)}
              onSearch={(val) => getShopsOptions(val)}
              filterOption={(input, option) =>
                option.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {shopsOptions.list.length ? (
                <Option value={null}>All Shops</Option>
              ) : undefined}
              {shopsOptions.list.map((shop: any, i) => (
                <Option value={shop?.id} key={i}>
                  {shop.name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Color Code"
            rules={[
              {
                required: true,
                message: "Color Code is Required!",
              },
            ]}
            name="colorCode"
          >
            <Input id="colorCode" type="color" placeholder="Enter Color Code" />
          </Form.Item>

          <Form.Item hasFeedback label="Campaign Parent" name="parentCampaign">
            <Select
              allowClear
              showSearch
              placeholder="Select Campaign Parent"
              optionFilterProp="children"
              onChange={(val) => setCampaignParentId(val)}
              filterOption={(input, option) =>
                option.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              <Select.Option value={""}>Select Parent</Select.Option>
              {campaignOptions.list.map(
                (
                  campaign: {
                    id: { index: any };
                    name:
                      | any
                      | React.ReactChild
                      | React.ReactFragment
                      | React.ReactPortal;
                  },
                  i
                ) => (
                  <Select.Option value={campaign?.id} key={i}>
                    {campaign?.name}
                  </Select.Option>
                )
              )}
            </Select>
          </Form.Item>

          <Form.Item hasFeedback label="Campaign Position" name="displayOrder">
            <Input
              id="displayOrder"
              type="number"
              placeholder="Enter Campaign Position"
            />
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Campaing Starting Date"
            rules={[
              {
                required: true,
                message: "Starting Date is Required!",
              },
            ]}
            name="startAt"
          >
            <DatePicker
              showTime
              id="startAt"
              placeholder="Enter Starting Date"
              style={{ minWidth: "100%" }}
              onChange={(val) => setFromDate(val?.format("lll"))}
              onSelect={(val) => setFromDate(val?.format("lll"))}
            />
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Campaing Ending Date"
            rules={[
              {
                required: true,
                message: "Ending Date is Required!",
              },
            ]}
            name="endAt"
          >
            <DatePicker
              showTime
              id="endAt"
              placeholder="Enter Ending Date"
              style={{ minWidth: "100%" }}
              onChange={(val) => setToDate(val?.format("lll"))}
              disabled={!fromDate}
              disabledDate={(currentDate) =>
                currentDate.isBefore(moment(fromDate))
              }
            />
          </Form.Item>

          <Form.Item
            style={{ minWidth: "100%" }}
            hasFeedback
            label="Description"
            rules={[
              {
                required: true,
                message: "Description is Required!",
              },
            ]}
            name="description"
          >
            <TextArea
              id="description"
              placeholder="Enter Campaign Description"
              rows={4}
            />
          </Form.Item>

          <h4 className="title" style={{ maxWidth: "99%" }}>
            Image:
          </h4>

          <div className="">
            <h6>Apps Image</h6>
            <ImageUploader
              imgUrl={appsImgUrl || ""}
              startUpload={startUpload}
              setStartUpload={(val) => setStartUpload(val)}
              setGeneratedImgUrl={(url) => setAppsImgUrl(url)}
              crop={2.56}
            />
          </div>
          <div className="">
            <h6>Web Image</h6>
            <ImageUploader
              imgUrl={webImgUrl || ""}
              startUpload={startUpload2}
              setStartUpload={(val) => setStartUpload2(val)}
              setGeneratedImgUrl={(url) => setWebImgUrl(url)}
              crop={1.9}
            />
          </div>

          <div className="buttons-container">
            <Button
              disabled={
                loading ||
                startUpload === "Uploading" ||
                startUpload2 === "Uploading"
              }
              loading={
                loading ||
                startUpload === "Uploading" ||
                startUpload2 === "Uploading"
              }
              type="primary"
              htmlType="submit"
              className="add-submit-btn text-center mr-2"
              onClick={(e) => {
                e.preventDefault();
                setStartUpload("Uploading");
                setStartUpload2("Uploading");
              }}
            >
              Submit
            </Button>
            <Button
              type="ghost"
              htmlType="button"
              onClick={resetData}
              className="reset-submit-btn text-center mr-2"
            >
              Reset
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AddCampaign;
